<template>
  <!-- <app-export-page-container> -->
  <div class="daily-by-code-export-page-container">
    <div id="viewer" dir="ltr"></div>

  </div>
  <!-- </app-export-page-container> -->
</template>
<script>
import ShearedMixin from '@/Mixins/Shared.js';
import ReportMixin from '@/Mixins/Report/ReportMixin.js';
// import AppExportPageContainer from '@/components/app/exportPageContainer.vue';
export default {
  name: 'app',
  inject: ['load'],
  mixins: [ShearedMixin, ReportMixin],
  // components: {
  //   AppExportPageContainer
  // },
  data() {
    return {
      reportType: '',
    };
  },
  created() { },
  mounted: function () {
    this.mounteLoding();
  },
  methods: {
    mounte: function () {
      let routeInfo = this.$route.params.id;
      let data = routeInfo.split('_');
      if (!isNaN(data[2])) {
        data[2] = Number(data[2]);
      } else {
        data[2] = null;
      }
      this.getDailyByZoneReportAmarFunction(data[0], data[1], data[2]);
    },
    makeDataReady: function (info) {
      /*JSON.stringify(info.items, function (key, value) {
      if (typeof value === "object" && value && !Array.isArray(value)) {
        return Object.keys(value).reduce(function (obj, k) {
          obj[k.charAt(0).toUpperCase() + k.slice(1)] = value[k];
          info = obj;
          return obj;
        }, {});
      }
      return value;
    });*/
      window.Stimulsoft.Base.StiLicense.Key =
        '6vJhGtLLLz2GNviWmUTrhSqnOItdDwjBylQzQcAOiHkcgIvwL0jnpsDqRpWg5FI5kt2G7A0tYIcUygBh1sPs7plofUOqPB1a4HBIXJB621mau2oiAIj+ysU7gKUXfjn/D5BocmduNB+ZMiDGPxFrAp3PoD0nYNkkWh8r7gBZ1v/JZSXGE3bQDrCQCNSy6mgby+iFAMV8/PuZ1z77U+Xz3fkpbm6MYQXYp3cQooLGLUti7k1TFWrnawT0iEEDJ2iRcU9wLqn2g9UiWesEZtKwI/UmEI2T7nv5NbgV+CHguu6QU4WWzFpIgW+3LUnKCT/vCDY+ymzgycw9A9+HFSzARiPzgOaAuQYrFDpzhXV+ZeX31AxWlnzjDWqpfluygSNPtGul5gyNt2CEoJD1Yom0VN9fvRonYsMsimkFFx2AwyVpPcs+JfVBtpPbTcZscnzUdmiIvxv8Gcin6sNSibM6in/uUKFt3bVgW/XeMYa7MLGF53kvBSwi78poUDigA2n12SmghLR0AHxyEDIgZGOTbNI33GWu7ZsPBeUdGu55R8w=';
      let options = new window.Stimulsoft.Viewer.StiViewerOptions();
      let viewer = new window.Stimulsoft.Viewer.StiViewer(options, 'StiViewer', false);

      let report = new window.Stimulsoft.Report.StiReport();
      let dataSet = new window.Stimulsoft.System.Data.DataSet('Data');
      dataSet.readJson(info.items);
      report.regData(dataSet.dataSetName, '', dataSet);
      report.loadFile('/Files/DailyReportMain.mrt');

      report.dictionary.variables.getByName('fromDate').valueObject = info.fromDate;
      report.dictionary.variables.getByName('toDate').valueObject = info.toDate;
      report.dictionary.variables.getByName('user').valueObject = info?.user;
      report.dictionary.variables.getByName('city').valueObject = info?.title;
      report.dictionary.variables.getByName('createDate').valueObject = info.reportDate;
      report.dictionary.variables.getByName('Consultant').valueObject =
        info?.callReport?.consultant;
      report.dictionary.variables.getByName('Other').valueObject = info?.callReport?.other;
      report.dictionary.variables.getByName('Prank').valueObject = info?.callReport?.prank;
      report.dictionary.variables.getByName('SendToDispatch').valueObject =
        info?.callReport?.sendToDispatch;
      viewer.report = report;
      viewer.options.toolbar.viewMode = window.Stimulsoft.Viewer.StiWebViewMode.Continuous;
      viewer.renderHtml('viewer');
      if (this.load.val) {
        this.load.val = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.daily-by-code-export-page-container {
  #StiViewer_JsViewerMainPanel {
    height: 100dvh !important;
    overflow: auto !important;
  }

  #StiViewerReportPanel {
    overflow: auto !important;
  }
}
</style>
<style scoped>
>>>text {
  transform: translateX(-50px) !important;
}
</style>
